/**
 * Profile views management functionality
 * Uses ListManagement for shared edit mode and removal logic
 */
(function() {
    'use strict';

    // Initialize on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', function() {
        // Only initialize on views page
        if (!document.querySelector('[data-viewers-container]')) return;

        // Initialize edit mode toggle
        window.ListManagement.initEditMode({
            deleteButtonClass: 'viewer-delete-btn'
        });

        // Delegate click events for delete buttons
        document.addEventListener('click', handleDeleteClick);
    });

    function handleDeleteClick(e) {
        var deleteBtn = e.target.closest('.viewer-delete-btn');
        if (!deleteBtn) return;

        e.preventDefault();
        e.stopPropagation();

        var viewerId = deleteBtn.dataset.viewerId;
        var username = deleteBtn.dataset.viewerUsername;

        window.ListManagement.confirmAndRemove({
            title: 'Remove View',
            message: 'Are you sure you want to remove ' + username + ' from your profile views?',
            fallbackMessage: 'Remove ' + username + ' from views?',
            onConfirm: function() {
                removeViewer(deleteBtn, viewerId);
            }
        });
    }

    function removeViewer(button, viewerId) {
        var card = button.closest('[data-viewer-card]');

        window.ListManagement.removeItem({
            button: button,
            card: card,
            url: '/app/views/delete',
            formData: { viewer_id: viewerId },
            errorMessage: 'Failed to remove view. Please try again.',
            logPrefix: 'View removal',
            onSuccess: updateViewersState
        });
    }

    function updateViewersState() {
        var container = document.querySelector('[data-viewers-container]');
        if (!container) return;

        var remaining = container.querySelectorAll('[data-viewer-card]').length;

        if (remaining === 0) {
            // Clone empty state from hidden template
            var template = document.getElementById('viewers-empty-state');
            if (template) {
                var emptyState = template.content.cloneNode(true);
                container.parentNode.replaceChild(emptyState, container);
            }
        }
    }
})();
